import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Box } from "@mui/material";
import PageContainer from "../../components/PageContainer/PageContainer";
import { URLs } from "../../utils/redirectStep";
import { getSessionDocument } from "services/sessionStorageService";
import useStyles from "assets/jss/material-react/views/italmundoStyles";

function SolicitudEnCurso() {
  const navigate = useNavigate();
  const location = useLocation();
  const classes = useStyles();

  const [modal, setModal] = useState({
    open: true,
    title: "Tenés una solicitud en curso",
    message:
      "Completá los pasos a continuación y empezá a disfrutar de tu Italmundo.",
    titlePink: true,
  });

  useEffect(() => {
    const documento = getSessionDocument();
    if (!documento) {
      navigate(URLs.home);
      return;
    }

    const { destinationUrl, destinationState } = location.state || {};
    if (!destinationUrl) {
      navigate(URLs.home);
      return;
    }

    const progressTimeout = setTimeout(() => {
      let progressValue = 0;
      const progressInterval = setInterval(() => {
        if (progressValue >= 100) {
          clearInterval(progressInterval);
        } else {
          progressValue += 10;
          setModal({
            open: true,
            showX: false,
            content: (
              <>
                <h3 className={classes.modalTitle}>
                  Estamos procesando tu información
                </h3>
                <p
                  className="special-font"
                  style={{
                    fontWeight: 700,
                    color: "#04808F",
                    marginTop: "1.5rem",
                    fontSize: "17px",
                  }}
                >
                  {progressValue}%
                </p>
                <Box
                  sx={{
                    width: "80%",
                    borderRadius: "5px",
                    padding: "2px",
                    border: "1px solid #04808F",
                    marginTop: "0.5rem",
                    marginBottom: "1.5rem",
                  }}
                >
                  <Box
                    sx={{
                      width: "100%",
                      backgroundColor: "#CDE6E9",
                      borderRadius: "5px",
                    }}
                  >
                    <Box
                      sx={{
                        width: `${progressValue}%`,
                        backgroundColor: "#04808F",
                        height: "20px",
                        borderRadius: "5px",
                      }}
                    />
                  </Box>
                </Box>
              </>
            ),
          });
        }
      }, 350);

      return () => clearInterval(progressInterval);
    }, 1500);

    const navigationTimeout = setTimeout(() => {
      navigate(
        destinationUrl,
        destinationState ? { state: destinationState } : undefined,
      );
    }, 5000);

    return () => {
      clearTimeout(progressTimeout);
      clearTimeout(navigationTimeout);
    };
  }, []);

  return (
    <PageContainer
      modal={modal}
      handleModalCloseClick={() => {}}
      canonicalUrl={URLs.solicitudEnCurso}
      noImage={true}
    />
  );
}

export default SolicitudEnCurso;
